import type {StateCreator} from 'zustand'
import type {State} from '../PullRequestStore'
import type {UserDiffViewSettings} from '@github-ui/diff-view-settings/types'

export type ViewSettingsSliceOpts = {
  viewSettings: UserDiffViewSettings | undefined
}

export type ViewSettingsSlice = {
  viewSettings: UserDiffViewSettings | undefined
  viewSettingsActions: {
    setViewSettings: (viewSettings: UserDiffViewSettings) => void
  }
}

export const createViewSettingsSlice =
  (opts: ViewSettingsSliceOpts): StateCreator<State, [], [], ViewSettingsSlice> =>
  set => ({
    viewSettings: opts.viewSettings,
    viewSettingsActions: {
      setViewSettings: viewSettings => set({viewSettings}),
    },
  })
